import {mapState, mapActions} from 'pinia'
import {useIndustryStore} from '@/stores'

export default {
  computed: {
    ...mapState(useIndustryStore, ['isFetchingIndustries', 'hasIndustriesFetched', 'industriesWithoutAll', 'isFetchingIndustryBusinesses', 'industryBusinesses'])
  },
  created () {
    this.fetchIndustries()
  },
  methods: {
    ...mapActions(useIndustryStore, ['fetchIndustries', 'fetchIndustryBusinesses', 'fetchSubIndustryBusinesses'])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/industries.js